// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main .logo[data-v-cd885f26]{padding-top:1.33333rem;text-align:center}.main .logo p[data-v-cd885f26]{font-size:.37333rem}", ""]);
// Exports
module.exports = exports;
